/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as _publicRouteRouteImport } from './routes/__public/route'
import { Route as _authenticatedRouteRouteImport } from './routes/__authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as _authenticatedDashboardRouteImport } from './routes/__authenticated/dashboard'
import { Route as _authenticatedClientsRouteImport } from './routes/__authenticated/clients'
import { Route as _publicNovoClienteIndexRouteImport } from './routes/__public/novo-cliente/index'
import { Route as _publicLoginIndexRouteImport } from './routes/__public/login/index'
import { Route as _publicCadastroRevendedorIndexRouteImport } from './routes/__public/cadastro-revendedor/index'
import { Route as _authenticatedSemPermissaoIndexRouteImport } from './routes/__authenticated/sem-permissao/index'
import { Route as _authenticatedAtendimentoIndexRouteImport } from './routes/__authenticated/atendimento/index'
import { Route as _publicNovoClienteVerifiqueSeuEmailRouteImport } from './routes/__public/novo-cliente/verifique-seu-email'
import { Route as _publicNovoClienteErroRouteImport } from './routes/__public/novo-cliente/erro'
import { Route as _publicAlunoLoginRouteImport } from './routes/__public/aluno/login'
import { Route as _authenticatedSuporteTreinamentosIndexRouteImport } from './routes/__authenticated/suporte/treinamentos/index'
import { Route as _authenticatedSuportePacoteComunicacaoIndexRouteImport } from './routes/__authenticated/suporte/pacote-comunicacao/index'
import { Route as _authenticatedComercialProdutoRelatorioRouteImport } from './routes/__authenticated/comercial/produto/relatorio'
import { Route as _authenticatedComercialProdutoMaterialGraficoRouteImport } from './routes/__authenticated/comercial/produto/material-grafico'
import { Route as _authenticatedComercialProdutoClientesRouteRouteImport } from './routes/__authenticated/comercial/produto/clientes/route'
import { Route as _authenticatedComercialProdutoRelatoriosIndexRouteImport } from './routes/__authenticated/comercial/produto/relatorios/index'
import { Route as _authenticatedComercialProdutoRegistrosIndexRouteImport } from './routes/__authenticated/comercial/produto/registros/index'
import { Route as _authenticatedComercialProdutoPrecosIndexRouteImport } from './routes/__authenticated/comercial/produto/precos/index'
import { Route as _authenticatedComercialProdutoClientesIndexRouteImport } from './routes/__authenticated/comercial/produto/clientes/index'
import { Route as _authenticatedComercialProdutoClientesWebCodigoRouteRouteImport } from './routes/__authenticated/comercial/produto/clientes/web/$codigo/route'
import { Route as _authenticatedComercialProdutoClientesHibridosIdRouteRouteImport } from './routes/__authenticated/comercial/produto/clientes/hibridos/$id/route'
import { Route as _authenticatedComercialProdutoClientesAquisicoesCodigoRouteRouteImport } from './routes/__authenticated/comercial/produto/clientes/aquisicoes/$codigo/route'
import { Route as _authenticatedComercialProdutoClientesWebCodigoOutrasSolicitacoesRouteImport } from './routes/__authenticated/comercial/produto/clientes/web/$codigo/outras-solicitacoes'
import { Route as _authenticatedComercialProdutoClientesWebCodigoMinhasSolicitacoesRouteImport } from './routes/__authenticated/comercial/produto/clientes/web/$codigo/minhas-solicitacoes'
import { Route as _authenticatedComercialProdutoClientesWebCodigoCancelarContratoRouteImport } from './routes/__authenticated/comercial/produto/clientes/web/$codigo/cancelar-contrato'
import { Route as _authenticatedComercialProdutoClientesWebCodigoBiowebRouteImport } from './routes/__authenticated/comercial/produto/clientes/web/$codigo/bioweb'
import { Route as _authenticatedComercialProdutoClientesHibridosIdOutrasSolicitacoesRouteImport } from './routes/__authenticated/comercial/produto/clientes/hibridos/$id/outras-solicitacoes'
import { Route as _authenticatedComercialProdutoClientesHibridosIdMinhasSolicitacoesRouteImport } from './routes/__authenticated/comercial/produto/clientes/hibridos/$id/minhas-solicitacoes'
import { Route as _authenticatedComercialProdutoClientesHibridosIdCancelarContratoRouteImport } from './routes/__authenticated/comercial/produto/clientes/hibridos/$id/cancelar-contrato'
import { Route as _authenticatedComercialProdutoClientesHibridosIdBiowebRouteImport } from './routes/__authenticated/comercial/produto/clientes/hibridos/$id/bioweb'
import { Route as _authenticatedComercialProdutoClientesAquisicoesCodigoOutrasSolicitacoesRouteImport } from './routes/__authenticated/comercial/produto/clientes/aquisicoes/$codigo/outras-solicitacoes'
import { Route as _authenticatedComercialProdutoClientesAquisicoesCodigoMinhasSolicitacoesRouteImport } from './routes/__authenticated/comercial/produto/clientes/aquisicoes/$codigo/minhas-solicitacoes'
import { Route as _authenticatedComercialProdutoClientesHibridosIdLocaisHdRouteRouteImport } from './routes/__authenticated/comercial/produto/clientes/hibridos/$id/locais-hd/route'
import { Route as _authenticatedComercialProdutoClientesHibridosIdBackupsRemotosRouteRouteImport } from './routes/__authenticated/comercial/produto/clientes/hibridos/$id/backups-remotos/route'
import { Route as _authenticatedComercialProdutoClientesWebCodigoEmpresasBancoIndexRouteImport } from './routes/__authenticated/comercial/produto/clientes/web/$codigo/empresas-banco/index'
import { Route as _authenticatedComercialProdutoClientesWebCodigoAlterarDadosIndexRouteImport } from './routes/__authenticated/comercial/produto/clientes/web/$codigo/alterar-dados/index'
import { Route as _authenticatedComercialProdutoClientesHibridosIdDadosSoftwareIndexRouteImport } from './routes/__authenticated/comercial/produto/clientes/hibridos/$id/dados-software/index'

const _publicRouteRoute = _publicRouteRouteImport.update({
  id: '/__public',
  getParentRoute: () => rootRouteImport,
} as any)
const _authenticatedRouteRoute = _authenticatedRouteRouteImport.update({
  id: '/__authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const _authenticatedDashboardRoute = _authenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => _authenticatedRouteRoute,
} as any)
const _authenticatedClientsRoute = _authenticatedClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => _authenticatedRouteRoute,
} as any)
const _publicNovoClienteIndexRoute = _publicNovoClienteIndexRouteImport.update({
  id: '/novo-cliente/',
  path: '/novo-cliente/',
  getParentRoute: () => _publicRouteRoute,
} as any)
const _publicLoginIndexRoute = _publicLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => _publicRouteRoute,
} as any)
const _publicCadastroRevendedorIndexRoute =
  _publicCadastroRevendedorIndexRouteImport.update({
    id: '/cadastro-revendedor/',
    path: '/cadastro-revendedor/',
    getParentRoute: () => _publicRouteRoute,
  } as any)
const _authenticatedSemPermissaoIndexRoute =
  _authenticatedSemPermissaoIndexRouteImport.update({
    id: '/sem-permissao/',
    path: '/sem-permissao/',
    getParentRoute: () => _authenticatedRouteRoute,
  } as any)
const _authenticatedAtendimentoIndexRoute =
  _authenticatedAtendimentoIndexRouteImport.update({
    id: '/atendimento/',
    path: '/atendimento/',
    getParentRoute: () => _authenticatedRouteRoute,
  } as any)
const _publicNovoClienteVerifiqueSeuEmailRoute =
  _publicNovoClienteVerifiqueSeuEmailRouteImport.update({
    id: '/novo-cliente/verifique-seu-email',
    path: '/novo-cliente/verifique-seu-email',
    getParentRoute: () => _publicRouteRoute,
  } as any)
const _publicNovoClienteErroRoute = _publicNovoClienteErroRouteImport.update({
  id: '/novo-cliente/erro',
  path: '/novo-cliente/erro',
  getParentRoute: () => _publicRouteRoute,
} as any)
const _publicAlunoLoginRoute = _publicAlunoLoginRouteImport.update({
  id: '/aluno/login',
  path: '/aluno/login',
  getParentRoute: () => _publicRouteRoute,
} as any)
const _authenticatedSuporteTreinamentosIndexRoute =
  _authenticatedSuporteTreinamentosIndexRouteImport.update({
    id: '/suporte/treinamentos/',
    path: '/suporte/treinamentos/',
    getParentRoute: () => _authenticatedRouteRoute,
  } as any)
const _authenticatedSuportePacoteComunicacaoIndexRoute =
  _authenticatedSuportePacoteComunicacaoIndexRouteImport.update({
    id: '/suporte/pacote-comunicacao/',
    path: '/suporte/pacote-comunicacao/',
    getParentRoute: () => _authenticatedRouteRoute,
  } as any)
const _authenticatedComercialProdutoRelatorioRoute =
  _authenticatedComercialProdutoRelatorioRouteImport.update({
    id: '/comercial/produto/relatorio',
    path: '/comercial/produto/relatorio',
    getParentRoute: () => _authenticatedRouteRoute,
  } as any)
const _authenticatedComercialProdutoMaterialGraficoRoute =
  _authenticatedComercialProdutoMaterialGraficoRouteImport.update({
    id: '/comercial/produto/material-grafico',
    path: '/comercial/produto/material-grafico',
    getParentRoute: () => _authenticatedRouteRoute,
  } as any)
const _authenticatedComercialProdutoClientesRouteRoute =
  _authenticatedComercialProdutoClientesRouteRouteImport.update({
    id: '/comercial/produto/clientes',
    path: '/comercial/produto/clientes',
    getParentRoute: () => _authenticatedRouteRoute,
  } as any)
const _authenticatedComercialProdutoRelatoriosIndexRoute =
  _authenticatedComercialProdutoRelatoriosIndexRouteImport.update({
    id: '/comercial/produto/relatorios/',
    path: '/comercial/produto/relatorios/',
    getParentRoute: () => _authenticatedRouteRoute,
  } as any)
const _authenticatedComercialProdutoRegistrosIndexRoute =
  _authenticatedComercialProdutoRegistrosIndexRouteImport.update({
    id: '/comercial/produto/registros/',
    path: '/comercial/produto/registros/',
    getParentRoute: () => _authenticatedRouteRoute,
  } as any)
const _authenticatedComercialProdutoPrecosIndexRoute =
  _authenticatedComercialProdutoPrecosIndexRouteImport.update({
    id: '/comercial/produto/precos/',
    path: '/comercial/produto/precos/',
    getParentRoute: () => _authenticatedRouteRoute,
  } as any)
const _authenticatedComercialProdutoClientesIndexRoute =
  _authenticatedComercialProdutoClientesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => _authenticatedComercialProdutoClientesRouteRoute,
  } as any)
const _authenticatedComercialProdutoClientesWebCodigoRouteRoute =
  _authenticatedComercialProdutoClientesWebCodigoRouteRouteImport.update({
    id: '/web/$codigo',
    path: '/web/$codigo',
    getParentRoute: () => _authenticatedComercialProdutoClientesRouteRoute,
  } as any)
const _authenticatedComercialProdutoClientesHibridosIdRouteRoute =
  _authenticatedComercialProdutoClientesHibridosIdRouteRouteImport.update({
    id: '/hibridos/$id',
    path: '/hibridos/$id',
    getParentRoute: () => _authenticatedComercialProdutoClientesRouteRoute,
  } as any)
const _authenticatedComercialProdutoClientesAquisicoesCodigoRouteRoute =
  _authenticatedComercialProdutoClientesAquisicoesCodigoRouteRouteImport.update(
    {
      id: '/aquisicoes/$codigo',
      path: '/aquisicoes/$codigo',
      getParentRoute: () => _authenticatedComercialProdutoClientesRouteRoute,
    } as any,
  )
const _authenticatedComercialProdutoClientesWebCodigoOutrasSolicitacoesRoute =
  _authenticatedComercialProdutoClientesWebCodigoOutrasSolicitacoesRouteImport.update(
    {
      id: '/outras-solicitacoes',
      path: '/outras-solicitacoes',
      getParentRoute: () =>
        _authenticatedComercialProdutoClientesWebCodigoRouteRoute,
    } as any,
  )
const _authenticatedComercialProdutoClientesWebCodigoMinhasSolicitacoesRoute =
  _authenticatedComercialProdutoClientesWebCodigoMinhasSolicitacoesRouteImport.update(
    {
      id: '/minhas-solicitacoes',
      path: '/minhas-solicitacoes',
      getParentRoute: () =>
        _authenticatedComercialProdutoClientesWebCodigoRouteRoute,
    } as any,
  )
const _authenticatedComercialProdutoClientesWebCodigoCancelarContratoRoute =
  _authenticatedComercialProdutoClientesWebCodigoCancelarContratoRouteImport.update(
    {
      id: '/cancelar-contrato',
      path: '/cancelar-contrato',
      getParentRoute: () =>
        _authenticatedComercialProdutoClientesWebCodigoRouteRoute,
    } as any,
  )
const _authenticatedComercialProdutoClientesWebCodigoBiowebRoute =
  _authenticatedComercialProdutoClientesWebCodigoBiowebRouteImport.update({
    id: '/bioweb',
    path: '/bioweb',
    getParentRoute: () =>
      _authenticatedComercialProdutoClientesWebCodigoRouteRoute,
  } as any)
const _authenticatedComercialProdutoClientesHibridosIdOutrasSolicitacoesRoute =
  _authenticatedComercialProdutoClientesHibridosIdOutrasSolicitacoesRouteImport.update(
    {
      id: '/outras-solicitacoes',
      path: '/outras-solicitacoes',
      getParentRoute: () =>
        _authenticatedComercialProdutoClientesHibridosIdRouteRoute,
    } as any,
  )
const _authenticatedComercialProdutoClientesHibridosIdMinhasSolicitacoesRoute =
  _authenticatedComercialProdutoClientesHibridosIdMinhasSolicitacoesRouteImport.update(
    {
      id: '/minhas-solicitacoes',
      path: '/minhas-solicitacoes',
      getParentRoute: () =>
        _authenticatedComercialProdutoClientesHibridosIdRouteRoute,
    } as any,
  )
const _authenticatedComercialProdutoClientesHibridosIdCancelarContratoRoute =
  _authenticatedComercialProdutoClientesHibridosIdCancelarContratoRouteImport.update(
    {
      id: '/cancelar-contrato',
      path: '/cancelar-contrato',
      getParentRoute: () =>
        _authenticatedComercialProdutoClientesHibridosIdRouteRoute,
    } as any,
  )
const _authenticatedComercialProdutoClientesHibridosIdBiowebRoute =
  _authenticatedComercialProdutoClientesHibridosIdBiowebRouteImport.update({
    id: '/bioweb',
    path: '/bioweb',
    getParentRoute: () =>
      _authenticatedComercialProdutoClientesHibridosIdRouteRoute,
  } as any)
const _authenticatedComercialProdutoClientesAquisicoesCodigoOutrasSolicitacoesRoute =
  _authenticatedComercialProdutoClientesAquisicoesCodigoOutrasSolicitacoesRouteImport.update(
    {
      id: '/outras-solicitacoes',
      path: '/outras-solicitacoes',
      getParentRoute: () =>
        _authenticatedComercialProdutoClientesAquisicoesCodigoRouteRoute,
    } as any,
  )
const _authenticatedComercialProdutoClientesAquisicoesCodigoMinhasSolicitacoesRoute =
  _authenticatedComercialProdutoClientesAquisicoesCodigoMinhasSolicitacoesRouteImport.update(
    {
      id: '/minhas-solicitacoes',
      path: '/minhas-solicitacoes',
      getParentRoute: () =>
        _authenticatedComercialProdutoClientesAquisicoesCodigoRouteRoute,
    } as any,
  )
const _authenticatedComercialProdutoClientesHibridosIdLocaisHdRouteRoute =
  _authenticatedComercialProdutoClientesHibridosIdLocaisHdRouteRouteImport.update(
    {
      id: '/locais-hd',
      path: '/locais-hd',
      getParentRoute: () =>
        _authenticatedComercialProdutoClientesHibridosIdRouteRoute,
    } as any,
  )
const _authenticatedComercialProdutoClientesHibridosIdBackupsRemotosRouteRoute =
  _authenticatedComercialProdutoClientesHibridosIdBackupsRemotosRouteRouteImport.update(
    {
      id: '/backups-remotos',
      path: '/backups-remotos',
      getParentRoute: () =>
        _authenticatedComercialProdutoClientesHibridosIdRouteRoute,
    } as any,
  )
const _authenticatedComercialProdutoClientesWebCodigoEmpresasBancoIndexRoute =
  _authenticatedComercialProdutoClientesWebCodigoEmpresasBancoIndexRouteImport.update(
    {
      id: '/empresas-banco/',
      path: '/empresas-banco/',
      getParentRoute: () =>
        _authenticatedComercialProdutoClientesWebCodigoRouteRoute,
    } as any,
  )
const _authenticatedComercialProdutoClientesWebCodigoAlterarDadosIndexRoute =
  _authenticatedComercialProdutoClientesWebCodigoAlterarDadosIndexRouteImport.update(
    {
      id: '/alterar-dados/',
      path: '/alterar-dados/',
      getParentRoute: () =>
        _authenticatedComercialProdutoClientesWebCodigoRouteRoute,
    } as any,
  )
const _authenticatedComercialProdutoClientesHibridosIdDadosSoftwareIndexRoute =
  _authenticatedComercialProdutoClientesHibridosIdDadosSoftwareIndexRouteImport.update(
    {
      id: '/dados-software/',
      path: '/dados-software/',
      getParentRoute: () =>
        _authenticatedComercialProdutoClientesHibridosIdRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/clients': typeof _authenticatedClientsRoute
  '/dashboard': typeof _authenticatedDashboardRoute
  '/aluno/login': typeof _publicAlunoLoginRoute
  '/novo-cliente/erro': typeof _publicNovoClienteErroRoute
  '/novo-cliente/verifique-seu-email': typeof _publicNovoClienteVerifiqueSeuEmailRoute
  '/atendimento/': typeof _authenticatedAtendimentoIndexRoute
  '/sem-permissao/': typeof _authenticatedSemPermissaoIndexRoute
  '/cadastro-revendedor/': typeof _publicCadastroRevendedorIndexRoute
  '/login/': typeof _publicLoginIndexRoute
  '/novo-cliente/': typeof _publicNovoClienteIndexRoute
  '/comercial/produto/clientes': typeof _authenticatedComercialProdutoClientesRouteRouteWithChildren
  '/comercial/produto/material-grafico': typeof _authenticatedComercialProdutoMaterialGraficoRoute
  '/comercial/produto/relatorio': typeof _authenticatedComercialProdutoRelatorioRoute
  '/suporte/pacote-comunicacao/': typeof _authenticatedSuportePacoteComunicacaoIndexRoute
  '/suporte/treinamentos/': typeof _authenticatedSuporteTreinamentosIndexRoute
  '/comercial/produto/clientes/': typeof _authenticatedComercialProdutoClientesIndexRoute
  '/comercial/produto/precos/': typeof _authenticatedComercialProdutoPrecosIndexRoute
  '/comercial/produto/registros/': typeof _authenticatedComercialProdutoRegistrosIndexRoute
  '/comercial/produto/relatorios/': typeof _authenticatedComercialProdutoRelatoriosIndexRoute
  '/comercial/produto/clientes/aquisicoes/$codigo': typeof _authenticatedComercialProdutoClientesAquisicoesCodigoRouteRouteWithChildren
  '/comercial/produto/clientes/hibridos/$id': typeof _authenticatedComercialProdutoClientesHibridosIdRouteRouteWithChildren
  '/comercial/produto/clientes/web/$codigo': typeof _authenticatedComercialProdutoClientesWebCodigoRouteRouteWithChildren
  '/comercial/produto/clientes/hibridos/$id/backups-remotos': typeof _authenticatedComercialProdutoClientesHibridosIdBackupsRemotosRouteRoute
  '/comercial/produto/clientes/hibridos/$id/locais-hd': typeof _authenticatedComercialProdutoClientesHibridosIdLocaisHdRouteRoute
  '/comercial/produto/clientes/aquisicoes/$codigo/minhas-solicitacoes': typeof _authenticatedComercialProdutoClientesAquisicoesCodigoMinhasSolicitacoesRoute
  '/comercial/produto/clientes/aquisicoes/$codigo/outras-solicitacoes': typeof _authenticatedComercialProdutoClientesAquisicoesCodigoOutrasSolicitacoesRoute
  '/comercial/produto/clientes/hibridos/$id/bioweb': typeof _authenticatedComercialProdutoClientesHibridosIdBiowebRoute
  '/comercial/produto/clientes/hibridos/$id/cancelar-contrato': typeof _authenticatedComercialProdutoClientesHibridosIdCancelarContratoRoute
  '/comercial/produto/clientes/hibridos/$id/minhas-solicitacoes': typeof _authenticatedComercialProdutoClientesHibridosIdMinhasSolicitacoesRoute
  '/comercial/produto/clientes/hibridos/$id/outras-solicitacoes': typeof _authenticatedComercialProdutoClientesHibridosIdOutrasSolicitacoesRoute
  '/comercial/produto/clientes/web/$codigo/bioweb': typeof _authenticatedComercialProdutoClientesWebCodigoBiowebRoute
  '/comercial/produto/clientes/web/$codigo/cancelar-contrato': typeof _authenticatedComercialProdutoClientesWebCodigoCancelarContratoRoute
  '/comercial/produto/clientes/web/$codigo/minhas-solicitacoes': typeof _authenticatedComercialProdutoClientesWebCodigoMinhasSolicitacoesRoute
  '/comercial/produto/clientes/web/$codigo/outras-solicitacoes': typeof _authenticatedComercialProdutoClientesWebCodigoOutrasSolicitacoesRoute
  '/comercial/produto/clientes/hibridos/$id/dados-software/': typeof _authenticatedComercialProdutoClientesHibridosIdDadosSoftwareIndexRoute
  '/comercial/produto/clientes/web/$codigo/alterar-dados/': typeof _authenticatedComercialProdutoClientesWebCodigoAlterarDadosIndexRoute
  '/comercial/produto/clientes/web/$codigo/empresas-banco/': typeof _authenticatedComercialProdutoClientesWebCodigoEmpresasBancoIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/clients': typeof _authenticatedClientsRoute
  '/dashboard': typeof _authenticatedDashboardRoute
  '/aluno/login': typeof _publicAlunoLoginRoute
  '/novo-cliente/erro': typeof _publicNovoClienteErroRoute
  '/novo-cliente/verifique-seu-email': typeof _publicNovoClienteVerifiqueSeuEmailRoute
  '/atendimento': typeof _authenticatedAtendimentoIndexRoute
  '/sem-permissao': typeof _authenticatedSemPermissaoIndexRoute
  '/cadastro-revendedor': typeof _publicCadastroRevendedorIndexRoute
  '/login': typeof _publicLoginIndexRoute
  '/novo-cliente': typeof _publicNovoClienteIndexRoute
  '/comercial/produto/material-grafico': typeof _authenticatedComercialProdutoMaterialGraficoRoute
  '/comercial/produto/relatorio': typeof _authenticatedComercialProdutoRelatorioRoute
  '/suporte/pacote-comunicacao': typeof _authenticatedSuportePacoteComunicacaoIndexRoute
  '/suporte/treinamentos': typeof _authenticatedSuporteTreinamentosIndexRoute
  '/comercial/produto/clientes': typeof _authenticatedComercialProdutoClientesIndexRoute
  '/comercial/produto/precos': typeof _authenticatedComercialProdutoPrecosIndexRoute
  '/comercial/produto/registros': typeof _authenticatedComercialProdutoRegistrosIndexRoute
  '/comercial/produto/relatorios': typeof _authenticatedComercialProdutoRelatoriosIndexRoute
  '/comercial/produto/clientes/aquisicoes/$codigo': typeof _authenticatedComercialProdutoClientesAquisicoesCodigoRouteRouteWithChildren
  '/comercial/produto/clientes/hibridos/$id': typeof _authenticatedComercialProdutoClientesHibridosIdRouteRouteWithChildren
  '/comercial/produto/clientes/web/$codigo': typeof _authenticatedComercialProdutoClientesWebCodigoRouteRouteWithChildren
  '/comercial/produto/clientes/hibridos/$id/backups-remotos': typeof _authenticatedComercialProdutoClientesHibridosIdBackupsRemotosRouteRoute
  '/comercial/produto/clientes/hibridos/$id/locais-hd': typeof _authenticatedComercialProdutoClientesHibridosIdLocaisHdRouteRoute
  '/comercial/produto/clientes/aquisicoes/$codigo/minhas-solicitacoes': typeof _authenticatedComercialProdutoClientesAquisicoesCodigoMinhasSolicitacoesRoute
  '/comercial/produto/clientes/aquisicoes/$codigo/outras-solicitacoes': typeof _authenticatedComercialProdutoClientesAquisicoesCodigoOutrasSolicitacoesRoute
  '/comercial/produto/clientes/hibridos/$id/bioweb': typeof _authenticatedComercialProdutoClientesHibridosIdBiowebRoute
  '/comercial/produto/clientes/hibridos/$id/cancelar-contrato': typeof _authenticatedComercialProdutoClientesHibridosIdCancelarContratoRoute
  '/comercial/produto/clientes/hibridos/$id/minhas-solicitacoes': typeof _authenticatedComercialProdutoClientesHibridosIdMinhasSolicitacoesRoute
  '/comercial/produto/clientes/hibridos/$id/outras-solicitacoes': typeof _authenticatedComercialProdutoClientesHibridosIdOutrasSolicitacoesRoute
  '/comercial/produto/clientes/web/$codigo/bioweb': typeof _authenticatedComercialProdutoClientesWebCodigoBiowebRoute
  '/comercial/produto/clientes/web/$codigo/cancelar-contrato': typeof _authenticatedComercialProdutoClientesWebCodigoCancelarContratoRoute
  '/comercial/produto/clientes/web/$codigo/minhas-solicitacoes': typeof _authenticatedComercialProdutoClientesWebCodigoMinhasSolicitacoesRoute
  '/comercial/produto/clientes/web/$codigo/outras-solicitacoes': typeof _authenticatedComercialProdutoClientesWebCodigoOutrasSolicitacoesRoute
  '/comercial/produto/clientes/hibridos/$id/dados-software': typeof _authenticatedComercialProdutoClientesHibridosIdDadosSoftwareIndexRoute
  '/comercial/produto/clientes/web/$codigo/alterar-dados': typeof _authenticatedComercialProdutoClientesWebCodigoAlterarDadosIndexRoute
  '/comercial/produto/clientes/web/$codigo/empresas-banco': typeof _authenticatedComercialProdutoClientesWebCodigoEmpresasBancoIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/__authenticated': typeof _authenticatedRouteRouteWithChildren
  '/__public': typeof _publicRouteRouteWithChildren
  '/__authenticated/clients': typeof _authenticatedClientsRoute
  '/__authenticated/dashboard': typeof _authenticatedDashboardRoute
  '/__public/aluno/login': typeof _publicAlunoLoginRoute
  '/__public/novo-cliente/erro': typeof _publicNovoClienteErroRoute
  '/__public/novo-cliente/verifique-seu-email': typeof _publicNovoClienteVerifiqueSeuEmailRoute
  '/__authenticated/atendimento/': typeof _authenticatedAtendimentoIndexRoute
  '/__authenticated/sem-permissao/': typeof _authenticatedSemPermissaoIndexRoute
  '/__public/cadastro-revendedor/': typeof _publicCadastroRevendedorIndexRoute
  '/__public/login/': typeof _publicLoginIndexRoute
  '/__public/novo-cliente/': typeof _publicNovoClienteIndexRoute
  '/__authenticated/comercial/produto/clientes': typeof _authenticatedComercialProdutoClientesRouteRouteWithChildren
  '/__authenticated/comercial/produto/material-grafico': typeof _authenticatedComercialProdutoMaterialGraficoRoute
  '/__authenticated/comercial/produto/relatorio': typeof _authenticatedComercialProdutoRelatorioRoute
  '/__authenticated/suporte/pacote-comunicacao/': typeof _authenticatedSuportePacoteComunicacaoIndexRoute
  '/__authenticated/suporte/treinamentos/': typeof _authenticatedSuporteTreinamentosIndexRoute
  '/__authenticated/comercial/produto/clientes/': typeof _authenticatedComercialProdutoClientesIndexRoute
  '/__authenticated/comercial/produto/precos/': typeof _authenticatedComercialProdutoPrecosIndexRoute
  '/__authenticated/comercial/produto/registros/': typeof _authenticatedComercialProdutoRegistrosIndexRoute
  '/__authenticated/comercial/produto/relatorios/': typeof _authenticatedComercialProdutoRelatoriosIndexRoute
  '/__authenticated/comercial/produto/clientes/aquisicoes/$codigo': typeof _authenticatedComercialProdutoClientesAquisicoesCodigoRouteRouteWithChildren
  '/__authenticated/comercial/produto/clientes/hibridos/$id': typeof _authenticatedComercialProdutoClientesHibridosIdRouteRouteWithChildren
  '/__authenticated/comercial/produto/clientes/web/$codigo': typeof _authenticatedComercialProdutoClientesWebCodigoRouteRouteWithChildren
  '/__authenticated/comercial/produto/clientes/hibridos/$id/backups-remotos': typeof _authenticatedComercialProdutoClientesHibridosIdBackupsRemotosRouteRoute
  '/__authenticated/comercial/produto/clientes/hibridos/$id/locais-hd': typeof _authenticatedComercialProdutoClientesHibridosIdLocaisHdRouteRoute
  '/__authenticated/comercial/produto/clientes/aquisicoes/$codigo/minhas-solicitacoes': typeof _authenticatedComercialProdutoClientesAquisicoesCodigoMinhasSolicitacoesRoute
  '/__authenticated/comercial/produto/clientes/aquisicoes/$codigo/outras-solicitacoes': typeof _authenticatedComercialProdutoClientesAquisicoesCodigoOutrasSolicitacoesRoute
  '/__authenticated/comercial/produto/clientes/hibridos/$id/bioweb': typeof _authenticatedComercialProdutoClientesHibridosIdBiowebRoute
  '/__authenticated/comercial/produto/clientes/hibridos/$id/cancelar-contrato': typeof _authenticatedComercialProdutoClientesHibridosIdCancelarContratoRoute
  '/__authenticated/comercial/produto/clientes/hibridos/$id/minhas-solicitacoes': typeof _authenticatedComercialProdutoClientesHibridosIdMinhasSolicitacoesRoute
  '/__authenticated/comercial/produto/clientes/hibridos/$id/outras-solicitacoes': typeof _authenticatedComercialProdutoClientesHibridosIdOutrasSolicitacoesRoute
  '/__authenticated/comercial/produto/clientes/web/$codigo/bioweb': typeof _authenticatedComercialProdutoClientesWebCodigoBiowebRoute
  '/__authenticated/comercial/produto/clientes/web/$codigo/cancelar-contrato': typeof _authenticatedComercialProdutoClientesWebCodigoCancelarContratoRoute
  '/__authenticated/comercial/produto/clientes/web/$codigo/minhas-solicitacoes': typeof _authenticatedComercialProdutoClientesWebCodigoMinhasSolicitacoesRoute
  '/__authenticated/comercial/produto/clientes/web/$codigo/outras-solicitacoes': typeof _authenticatedComercialProdutoClientesWebCodigoOutrasSolicitacoesRoute
  '/__authenticated/comercial/produto/clientes/hibridos/$id/dados-software/': typeof _authenticatedComercialProdutoClientesHibridosIdDadosSoftwareIndexRoute
  '/__authenticated/comercial/produto/clientes/web/$codigo/alterar-dados/': typeof _authenticatedComercialProdutoClientesWebCodigoAlterarDadosIndexRoute
  '/__authenticated/comercial/produto/clientes/web/$codigo/empresas-banco/': typeof _authenticatedComercialProdutoClientesWebCodigoEmpresasBancoIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/clients'
    | '/dashboard'
    | '/aluno/login'
    | '/novo-cliente/erro'
    | '/novo-cliente/verifique-seu-email'
    | '/atendimento/'
    | '/sem-permissao/'
    | '/cadastro-revendedor/'
    | '/login/'
    | '/novo-cliente/'
    | '/comercial/produto/clientes'
    | '/comercial/produto/material-grafico'
    | '/comercial/produto/relatorio'
    | '/suporte/pacote-comunicacao/'
    | '/suporte/treinamentos/'
    | '/comercial/produto/clientes/'
    | '/comercial/produto/precos/'
    | '/comercial/produto/registros/'
    | '/comercial/produto/relatorios/'
    | '/comercial/produto/clientes/aquisicoes/$codigo'
    | '/comercial/produto/clientes/hibridos/$id'
    | '/comercial/produto/clientes/web/$codigo'
    | '/comercial/produto/clientes/hibridos/$id/backups-remotos'
    | '/comercial/produto/clientes/hibridos/$id/locais-hd'
    | '/comercial/produto/clientes/aquisicoes/$codigo/minhas-solicitacoes'
    | '/comercial/produto/clientes/aquisicoes/$codigo/outras-solicitacoes'
    | '/comercial/produto/clientes/hibridos/$id/bioweb'
    | '/comercial/produto/clientes/hibridos/$id/cancelar-contrato'
    | '/comercial/produto/clientes/hibridos/$id/minhas-solicitacoes'
    | '/comercial/produto/clientes/hibridos/$id/outras-solicitacoes'
    | '/comercial/produto/clientes/web/$codigo/bioweb'
    | '/comercial/produto/clientes/web/$codigo/cancelar-contrato'
    | '/comercial/produto/clientes/web/$codigo/minhas-solicitacoes'
    | '/comercial/produto/clientes/web/$codigo/outras-solicitacoes'
    | '/comercial/produto/clientes/hibridos/$id/dados-software/'
    | '/comercial/produto/clientes/web/$codigo/alterar-dados/'
    | '/comercial/produto/clientes/web/$codigo/empresas-banco/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/clients'
    | '/dashboard'
    | '/aluno/login'
    | '/novo-cliente/erro'
    | '/novo-cliente/verifique-seu-email'
    | '/atendimento'
    | '/sem-permissao'
    | '/cadastro-revendedor'
    | '/login'
    | '/novo-cliente'
    | '/comercial/produto/material-grafico'
    | '/comercial/produto/relatorio'
    | '/suporte/pacote-comunicacao'
    | '/suporte/treinamentos'
    | '/comercial/produto/clientes'
    | '/comercial/produto/precos'
    | '/comercial/produto/registros'
    | '/comercial/produto/relatorios'
    | '/comercial/produto/clientes/aquisicoes/$codigo'
    | '/comercial/produto/clientes/hibridos/$id'
    | '/comercial/produto/clientes/web/$codigo'
    | '/comercial/produto/clientes/hibridos/$id/backups-remotos'
    | '/comercial/produto/clientes/hibridos/$id/locais-hd'
    | '/comercial/produto/clientes/aquisicoes/$codigo/minhas-solicitacoes'
    | '/comercial/produto/clientes/aquisicoes/$codigo/outras-solicitacoes'
    | '/comercial/produto/clientes/hibridos/$id/bioweb'
    | '/comercial/produto/clientes/hibridos/$id/cancelar-contrato'
    | '/comercial/produto/clientes/hibridos/$id/minhas-solicitacoes'
    | '/comercial/produto/clientes/hibridos/$id/outras-solicitacoes'
    | '/comercial/produto/clientes/web/$codigo/bioweb'
    | '/comercial/produto/clientes/web/$codigo/cancelar-contrato'
    | '/comercial/produto/clientes/web/$codigo/minhas-solicitacoes'
    | '/comercial/produto/clientes/web/$codigo/outras-solicitacoes'
    | '/comercial/produto/clientes/hibridos/$id/dados-software'
    | '/comercial/produto/clientes/web/$codigo/alterar-dados'
    | '/comercial/produto/clientes/web/$codigo/empresas-banco'
  id:
    | '__root__'
    | '/'
    | '/__authenticated'
    | '/__public'
    | '/__authenticated/clients'
    | '/__authenticated/dashboard'
    | '/__public/aluno/login'
    | '/__public/novo-cliente/erro'
    | '/__public/novo-cliente/verifique-seu-email'
    | '/__authenticated/atendimento/'
    | '/__authenticated/sem-permissao/'
    | '/__public/cadastro-revendedor/'
    | '/__public/login/'
    | '/__public/novo-cliente/'
    | '/__authenticated/comercial/produto/clientes'
    | '/__authenticated/comercial/produto/material-grafico'
    | '/__authenticated/comercial/produto/relatorio'
    | '/__authenticated/suporte/pacote-comunicacao/'
    | '/__authenticated/suporte/treinamentos/'
    | '/__authenticated/comercial/produto/clientes/'
    | '/__authenticated/comercial/produto/precos/'
    | '/__authenticated/comercial/produto/registros/'
    | '/__authenticated/comercial/produto/relatorios/'
    | '/__authenticated/comercial/produto/clientes/aquisicoes/$codigo'
    | '/__authenticated/comercial/produto/clientes/hibridos/$id'
    | '/__authenticated/comercial/produto/clientes/web/$codigo'
    | '/__authenticated/comercial/produto/clientes/hibridos/$id/backups-remotos'
    | '/__authenticated/comercial/produto/clientes/hibridos/$id/locais-hd'
    | '/__authenticated/comercial/produto/clientes/aquisicoes/$codigo/minhas-solicitacoes'
    | '/__authenticated/comercial/produto/clientes/aquisicoes/$codigo/outras-solicitacoes'
    | '/__authenticated/comercial/produto/clientes/hibridos/$id/bioweb'
    | '/__authenticated/comercial/produto/clientes/hibridos/$id/cancelar-contrato'
    | '/__authenticated/comercial/produto/clientes/hibridos/$id/minhas-solicitacoes'
    | '/__authenticated/comercial/produto/clientes/hibridos/$id/outras-solicitacoes'
    | '/__authenticated/comercial/produto/clientes/web/$codigo/bioweb'
    | '/__authenticated/comercial/produto/clientes/web/$codigo/cancelar-contrato'
    | '/__authenticated/comercial/produto/clientes/web/$codigo/minhas-solicitacoes'
    | '/__authenticated/comercial/produto/clientes/web/$codigo/outras-solicitacoes'
    | '/__authenticated/comercial/produto/clientes/hibridos/$id/dados-software/'
    | '/__authenticated/comercial/produto/clientes/web/$codigo/alterar-dados/'
    | '/__authenticated/comercial/produto/clientes/web/$codigo/empresas-banco/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  _authenticatedRouteRoute: typeof _authenticatedRouteRouteWithChildren
  _publicRouteRoute: typeof _publicRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/__public': {
      id: '/__public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof _publicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/__authenticated': {
      id: '/__authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof _authenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/__authenticated/dashboard': {
      id: '/__authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof _authenticatedDashboardRouteImport
      parentRoute: typeof _authenticatedRouteRoute
    }
    '/__authenticated/clients': {
      id: '/__authenticated/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof _authenticatedClientsRouteImport
      parentRoute: typeof _authenticatedRouteRoute
    }
    '/__public/novo-cliente/': {
      id: '/__public/novo-cliente/'
      path: '/novo-cliente'
      fullPath: '/novo-cliente/'
      preLoaderRoute: typeof _publicNovoClienteIndexRouteImport
      parentRoute: typeof _publicRouteRoute
    }
    '/__public/login/': {
      id: '/__public/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof _publicLoginIndexRouteImport
      parentRoute: typeof _publicRouteRoute
    }
    '/__public/cadastro-revendedor/': {
      id: '/__public/cadastro-revendedor/'
      path: '/cadastro-revendedor'
      fullPath: '/cadastro-revendedor/'
      preLoaderRoute: typeof _publicCadastroRevendedorIndexRouteImport
      parentRoute: typeof _publicRouteRoute
    }
    '/__authenticated/sem-permissao/': {
      id: '/__authenticated/sem-permissao/'
      path: '/sem-permissao'
      fullPath: '/sem-permissao/'
      preLoaderRoute: typeof _authenticatedSemPermissaoIndexRouteImport
      parentRoute: typeof _authenticatedRouteRoute
    }
    '/__authenticated/atendimento/': {
      id: '/__authenticated/atendimento/'
      path: '/atendimento'
      fullPath: '/atendimento/'
      preLoaderRoute: typeof _authenticatedAtendimentoIndexRouteImport
      parentRoute: typeof _authenticatedRouteRoute
    }
    '/__public/novo-cliente/verifique-seu-email': {
      id: '/__public/novo-cliente/verifique-seu-email'
      path: '/novo-cliente/verifique-seu-email'
      fullPath: '/novo-cliente/verifique-seu-email'
      preLoaderRoute: typeof _publicNovoClienteVerifiqueSeuEmailRouteImport
      parentRoute: typeof _publicRouteRoute
    }
    '/__public/novo-cliente/erro': {
      id: '/__public/novo-cliente/erro'
      path: '/novo-cliente/erro'
      fullPath: '/novo-cliente/erro'
      preLoaderRoute: typeof _publicNovoClienteErroRouteImport
      parentRoute: typeof _publicRouteRoute
    }
    '/__public/aluno/login': {
      id: '/__public/aluno/login'
      path: '/aluno/login'
      fullPath: '/aluno/login'
      preLoaderRoute: typeof _publicAlunoLoginRouteImport
      parentRoute: typeof _publicRouteRoute
    }
    '/__authenticated/suporte/treinamentos/': {
      id: '/__authenticated/suporte/treinamentos/'
      path: '/suporte/treinamentos'
      fullPath: '/suporte/treinamentos/'
      preLoaderRoute: typeof _authenticatedSuporteTreinamentosIndexRouteImport
      parentRoute: typeof _authenticatedRouteRoute
    }
    '/__authenticated/suporte/pacote-comunicacao/': {
      id: '/__authenticated/suporte/pacote-comunicacao/'
      path: '/suporte/pacote-comunicacao'
      fullPath: '/suporte/pacote-comunicacao/'
      preLoaderRoute: typeof _authenticatedSuportePacoteComunicacaoIndexRouteImport
      parentRoute: typeof _authenticatedRouteRoute
    }
    '/__authenticated/comercial/produto/relatorio': {
      id: '/__authenticated/comercial/produto/relatorio'
      path: '/comercial/produto/relatorio'
      fullPath: '/comercial/produto/relatorio'
      preLoaderRoute: typeof _authenticatedComercialProdutoRelatorioRouteImport
      parentRoute: typeof _authenticatedRouteRoute
    }
    '/__authenticated/comercial/produto/material-grafico': {
      id: '/__authenticated/comercial/produto/material-grafico'
      path: '/comercial/produto/material-grafico'
      fullPath: '/comercial/produto/material-grafico'
      preLoaderRoute: typeof _authenticatedComercialProdutoMaterialGraficoRouteImport
      parentRoute: typeof _authenticatedRouteRoute
    }
    '/__authenticated/comercial/produto/clientes': {
      id: '/__authenticated/comercial/produto/clientes'
      path: '/comercial/produto/clientes'
      fullPath: '/comercial/produto/clientes'
      preLoaderRoute: typeof _authenticatedComercialProdutoClientesRouteRouteImport
      parentRoute: typeof _authenticatedRouteRoute
    }
    '/__authenticated/comercial/produto/relatorios/': {
      id: '/__authenticated/comercial/produto/relatorios/'
      path: '/comercial/produto/relatorios'
      fullPath: '/comercial/produto/relatorios/'
      preLoaderRoute: typeof _authenticatedComercialProdutoRelatoriosIndexRouteImport
      parentRoute: typeof _authenticatedRouteRoute
    }
    '/__authenticated/comercial/produto/registros/': {
      id: '/__authenticated/comercial/produto/registros/'
      path: '/comercial/produto/registros'
      fullPath: '/comercial/produto/registros/'
      preLoaderRoute: typeof _authenticatedComercialProdutoRegistrosIndexRouteImport
      parentRoute: typeof _authenticatedRouteRoute
    }
    '/__authenticated/comercial/produto/precos/': {
      id: '/__authenticated/comercial/produto/precos/'
      path: '/comercial/produto/precos'
      fullPath: '/comercial/produto/precos/'
      preLoaderRoute: typeof _authenticatedComercialProdutoPrecosIndexRouteImport
      parentRoute: typeof _authenticatedRouteRoute
    }
    '/__authenticated/comercial/produto/clientes/': {
      id: '/__authenticated/comercial/produto/clientes/'
      path: '/'
      fullPath: '/comercial/produto/clientes/'
      preLoaderRoute: typeof _authenticatedComercialProdutoClientesIndexRouteImport
      parentRoute: typeof _authenticatedComercialProdutoClientesRouteRoute
    }
    '/__authenticated/comercial/produto/clientes/web/$codigo': {
      id: '/__authenticated/comercial/produto/clientes/web/$codigo'
      path: '/web/$codigo'
      fullPath: '/comercial/produto/clientes/web/$codigo'
      preLoaderRoute: typeof _authenticatedComercialProdutoClientesWebCodigoRouteRouteImport
      parentRoute: typeof _authenticatedComercialProdutoClientesRouteRoute
    }
    '/__authenticated/comercial/produto/clientes/hibridos/$id': {
      id: '/__authenticated/comercial/produto/clientes/hibridos/$id'
      path: '/hibridos/$id'
      fullPath: '/comercial/produto/clientes/hibridos/$id'
      preLoaderRoute: typeof _authenticatedComercialProdutoClientesHibridosIdRouteRouteImport
      parentRoute: typeof _authenticatedComercialProdutoClientesRouteRoute
    }
    '/__authenticated/comercial/produto/clientes/aquisicoes/$codigo': {
      id: '/__authenticated/comercial/produto/clientes/aquisicoes/$codigo'
      path: '/aquisicoes/$codigo'
      fullPath: '/comercial/produto/clientes/aquisicoes/$codigo'
      preLoaderRoute: typeof _authenticatedComercialProdutoClientesAquisicoesCodigoRouteRouteImport
      parentRoute: typeof _authenticatedComercialProdutoClientesRouteRoute
    }
    '/__authenticated/comercial/produto/clientes/web/$codigo/outras-solicitacoes': {
      id: '/__authenticated/comercial/produto/clientes/web/$codigo/outras-solicitacoes'
      path: '/outras-solicitacoes'
      fullPath: '/comercial/produto/clientes/web/$codigo/outras-solicitacoes'
      preLoaderRoute: typeof _authenticatedComercialProdutoClientesWebCodigoOutrasSolicitacoesRouteImport
      parentRoute: typeof _authenticatedComercialProdutoClientesWebCodigoRouteRoute
    }
    '/__authenticated/comercial/produto/clientes/web/$codigo/minhas-solicitacoes': {
      id: '/__authenticated/comercial/produto/clientes/web/$codigo/minhas-solicitacoes'
      path: '/minhas-solicitacoes'
      fullPath: '/comercial/produto/clientes/web/$codigo/minhas-solicitacoes'
      preLoaderRoute: typeof _authenticatedComercialProdutoClientesWebCodigoMinhasSolicitacoesRouteImport
      parentRoute: typeof _authenticatedComercialProdutoClientesWebCodigoRouteRoute
    }
    '/__authenticated/comercial/produto/clientes/web/$codigo/cancelar-contrato': {
      id: '/__authenticated/comercial/produto/clientes/web/$codigo/cancelar-contrato'
      path: '/cancelar-contrato'
      fullPath: '/comercial/produto/clientes/web/$codigo/cancelar-contrato'
      preLoaderRoute: typeof _authenticatedComercialProdutoClientesWebCodigoCancelarContratoRouteImport
      parentRoute: typeof _authenticatedComercialProdutoClientesWebCodigoRouteRoute
    }
    '/__authenticated/comercial/produto/clientes/web/$codigo/bioweb': {
      id: '/__authenticated/comercial/produto/clientes/web/$codigo/bioweb'
      path: '/bioweb'
      fullPath: '/comercial/produto/clientes/web/$codigo/bioweb'
      preLoaderRoute: typeof _authenticatedComercialProdutoClientesWebCodigoBiowebRouteImport
      parentRoute: typeof _authenticatedComercialProdutoClientesWebCodigoRouteRoute
    }
    '/__authenticated/comercial/produto/clientes/hibridos/$id/outras-solicitacoes': {
      id: '/__authenticated/comercial/produto/clientes/hibridos/$id/outras-solicitacoes'
      path: '/outras-solicitacoes'
      fullPath: '/comercial/produto/clientes/hibridos/$id/outras-solicitacoes'
      preLoaderRoute: typeof _authenticatedComercialProdutoClientesHibridosIdOutrasSolicitacoesRouteImport
      parentRoute: typeof _authenticatedComercialProdutoClientesHibridosIdRouteRoute
    }
    '/__authenticated/comercial/produto/clientes/hibridos/$id/minhas-solicitacoes': {
      id: '/__authenticated/comercial/produto/clientes/hibridos/$id/minhas-solicitacoes'
      path: '/minhas-solicitacoes'
      fullPath: '/comercial/produto/clientes/hibridos/$id/minhas-solicitacoes'
      preLoaderRoute: typeof _authenticatedComercialProdutoClientesHibridosIdMinhasSolicitacoesRouteImport
      parentRoute: typeof _authenticatedComercialProdutoClientesHibridosIdRouteRoute
    }
    '/__authenticated/comercial/produto/clientes/hibridos/$id/cancelar-contrato': {
      id: '/__authenticated/comercial/produto/clientes/hibridos/$id/cancelar-contrato'
      path: '/cancelar-contrato'
      fullPath: '/comercial/produto/clientes/hibridos/$id/cancelar-contrato'
      preLoaderRoute: typeof _authenticatedComercialProdutoClientesHibridosIdCancelarContratoRouteImport
      parentRoute: typeof _authenticatedComercialProdutoClientesHibridosIdRouteRoute
    }
    '/__authenticated/comercial/produto/clientes/hibridos/$id/bioweb': {
      id: '/__authenticated/comercial/produto/clientes/hibridos/$id/bioweb'
      path: '/bioweb'
      fullPath: '/comercial/produto/clientes/hibridos/$id/bioweb'
      preLoaderRoute: typeof _authenticatedComercialProdutoClientesHibridosIdBiowebRouteImport
      parentRoute: typeof _authenticatedComercialProdutoClientesHibridosIdRouteRoute
    }
    '/__authenticated/comercial/produto/clientes/aquisicoes/$codigo/outras-solicitacoes': {
      id: '/__authenticated/comercial/produto/clientes/aquisicoes/$codigo/outras-solicitacoes'
      path: '/outras-solicitacoes'
      fullPath: '/comercial/produto/clientes/aquisicoes/$codigo/outras-solicitacoes'
      preLoaderRoute: typeof _authenticatedComercialProdutoClientesAquisicoesCodigoOutrasSolicitacoesRouteImport
      parentRoute: typeof _authenticatedComercialProdutoClientesAquisicoesCodigoRouteRoute
    }
    '/__authenticated/comercial/produto/clientes/aquisicoes/$codigo/minhas-solicitacoes': {
      id: '/__authenticated/comercial/produto/clientes/aquisicoes/$codigo/minhas-solicitacoes'
      path: '/minhas-solicitacoes'
      fullPath: '/comercial/produto/clientes/aquisicoes/$codigo/minhas-solicitacoes'
      preLoaderRoute: typeof _authenticatedComercialProdutoClientesAquisicoesCodigoMinhasSolicitacoesRouteImport
      parentRoute: typeof _authenticatedComercialProdutoClientesAquisicoesCodigoRouteRoute
    }
    '/__authenticated/comercial/produto/clientes/hibridos/$id/locais-hd': {
      id: '/__authenticated/comercial/produto/clientes/hibridos/$id/locais-hd'
      path: '/locais-hd'
      fullPath: '/comercial/produto/clientes/hibridos/$id/locais-hd'
      preLoaderRoute: typeof _authenticatedComercialProdutoClientesHibridosIdLocaisHdRouteRouteImport
      parentRoute: typeof _authenticatedComercialProdutoClientesHibridosIdRouteRoute
    }
    '/__authenticated/comercial/produto/clientes/hibridos/$id/backups-remotos': {
      id: '/__authenticated/comercial/produto/clientes/hibridos/$id/backups-remotos'
      path: '/backups-remotos'
      fullPath: '/comercial/produto/clientes/hibridos/$id/backups-remotos'
      preLoaderRoute: typeof _authenticatedComercialProdutoClientesHibridosIdBackupsRemotosRouteRouteImport
      parentRoute: typeof _authenticatedComercialProdutoClientesHibridosIdRouteRoute
    }
    '/__authenticated/comercial/produto/clientes/web/$codigo/empresas-banco/': {
      id: '/__authenticated/comercial/produto/clientes/web/$codigo/empresas-banco/'
      path: '/empresas-banco'
      fullPath: '/comercial/produto/clientes/web/$codigo/empresas-banco/'
      preLoaderRoute: typeof _authenticatedComercialProdutoClientesWebCodigoEmpresasBancoIndexRouteImport
      parentRoute: typeof _authenticatedComercialProdutoClientesWebCodigoRouteRoute
    }
    '/__authenticated/comercial/produto/clientes/web/$codigo/alterar-dados/': {
      id: '/__authenticated/comercial/produto/clientes/web/$codigo/alterar-dados/'
      path: '/alterar-dados'
      fullPath: '/comercial/produto/clientes/web/$codigo/alterar-dados/'
      preLoaderRoute: typeof _authenticatedComercialProdutoClientesWebCodigoAlterarDadosIndexRouteImport
      parentRoute: typeof _authenticatedComercialProdutoClientesWebCodigoRouteRoute
    }
    '/__authenticated/comercial/produto/clientes/hibridos/$id/dados-software/': {
      id: '/__authenticated/comercial/produto/clientes/hibridos/$id/dados-software/'
      path: '/dados-software'
      fullPath: '/comercial/produto/clientes/hibridos/$id/dados-software/'
      preLoaderRoute: typeof _authenticatedComercialProdutoClientesHibridosIdDadosSoftwareIndexRouteImport
      parentRoute: typeof _authenticatedComercialProdutoClientesHibridosIdRouteRoute
    }
  }
}

interface _authenticatedComercialProdutoClientesAquisicoesCodigoRouteRouteChildren {
  _authenticatedComercialProdutoClientesAquisicoesCodigoMinhasSolicitacoesRoute: typeof _authenticatedComercialProdutoClientesAquisicoesCodigoMinhasSolicitacoesRoute
  _authenticatedComercialProdutoClientesAquisicoesCodigoOutrasSolicitacoesRoute: typeof _authenticatedComercialProdutoClientesAquisicoesCodigoOutrasSolicitacoesRoute
}

const _authenticatedComercialProdutoClientesAquisicoesCodigoRouteRouteChildren: _authenticatedComercialProdutoClientesAquisicoesCodigoRouteRouteChildren =
  {
    _authenticatedComercialProdutoClientesAquisicoesCodigoMinhasSolicitacoesRoute:
      _authenticatedComercialProdutoClientesAquisicoesCodigoMinhasSolicitacoesRoute,
    _authenticatedComercialProdutoClientesAquisicoesCodigoOutrasSolicitacoesRoute:
      _authenticatedComercialProdutoClientesAquisicoesCodigoOutrasSolicitacoesRoute,
  }

const _authenticatedComercialProdutoClientesAquisicoesCodigoRouteRouteWithChildren =
  _authenticatedComercialProdutoClientesAquisicoesCodigoRouteRoute._addFileChildren(
    _authenticatedComercialProdutoClientesAquisicoesCodigoRouteRouteChildren,
  )

interface _authenticatedComercialProdutoClientesHibridosIdRouteRouteChildren {
  _authenticatedComercialProdutoClientesHibridosIdBackupsRemotosRouteRoute: typeof _authenticatedComercialProdutoClientesHibridosIdBackupsRemotosRouteRoute
  _authenticatedComercialProdutoClientesHibridosIdLocaisHdRouteRoute: typeof _authenticatedComercialProdutoClientesHibridosIdLocaisHdRouteRoute
  _authenticatedComercialProdutoClientesHibridosIdBiowebRoute: typeof _authenticatedComercialProdutoClientesHibridosIdBiowebRoute
  _authenticatedComercialProdutoClientesHibridosIdCancelarContratoRoute: typeof _authenticatedComercialProdutoClientesHibridosIdCancelarContratoRoute
  _authenticatedComercialProdutoClientesHibridosIdMinhasSolicitacoesRoute: typeof _authenticatedComercialProdutoClientesHibridosIdMinhasSolicitacoesRoute
  _authenticatedComercialProdutoClientesHibridosIdOutrasSolicitacoesRoute: typeof _authenticatedComercialProdutoClientesHibridosIdOutrasSolicitacoesRoute
  _authenticatedComercialProdutoClientesHibridosIdDadosSoftwareIndexRoute: typeof _authenticatedComercialProdutoClientesHibridosIdDadosSoftwareIndexRoute
}

const _authenticatedComercialProdutoClientesHibridosIdRouteRouteChildren: _authenticatedComercialProdutoClientesHibridosIdRouteRouteChildren =
  {
    _authenticatedComercialProdutoClientesHibridosIdBackupsRemotosRouteRoute:
      _authenticatedComercialProdutoClientesHibridosIdBackupsRemotosRouteRoute,
    _authenticatedComercialProdutoClientesHibridosIdLocaisHdRouteRoute:
      _authenticatedComercialProdutoClientesHibridosIdLocaisHdRouteRoute,
    _authenticatedComercialProdutoClientesHibridosIdBiowebRoute:
      _authenticatedComercialProdutoClientesHibridosIdBiowebRoute,
    _authenticatedComercialProdutoClientesHibridosIdCancelarContratoRoute:
      _authenticatedComercialProdutoClientesHibridosIdCancelarContratoRoute,
    _authenticatedComercialProdutoClientesHibridosIdMinhasSolicitacoesRoute:
      _authenticatedComercialProdutoClientesHibridosIdMinhasSolicitacoesRoute,
    _authenticatedComercialProdutoClientesHibridosIdOutrasSolicitacoesRoute:
      _authenticatedComercialProdutoClientesHibridosIdOutrasSolicitacoesRoute,
    _authenticatedComercialProdutoClientesHibridosIdDadosSoftwareIndexRoute:
      _authenticatedComercialProdutoClientesHibridosIdDadosSoftwareIndexRoute,
  }

const _authenticatedComercialProdutoClientesHibridosIdRouteRouteWithChildren =
  _authenticatedComercialProdutoClientesHibridosIdRouteRoute._addFileChildren(
    _authenticatedComercialProdutoClientesHibridosIdRouteRouteChildren,
  )

interface _authenticatedComercialProdutoClientesWebCodigoRouteRouteChildren {
  _authenticatedComercialProdutoClientesWebCodigoBiowebRoute: typeof _authenticatedComercialProdutoClientesWebCodigoBiowebRoute
  _authenticatedComercialProdutoClientesWebCodigoCancelarContratoRoute: typeof _authenticatedComercialProdutoClientesWebCodigoCancelarContratoRoute
  _authenticatedComercialProdutoClientesWebCodigoMinhasSolicitacoesRoute: typeof _authenticatedComercialProdutoClientesWebCodigoMinhasSolicitacoesRoute
  _authenticatedComercialProdutoClientesWebCodigoOutrasSolicitacoesRoute: typeof _authenticatedComercialProdutoClientesWebCodigoOutrasSolicitacoesRoute
  _authenticatedComercialProdutoClientesWebCodigoAlterarDadosIndexRoute: typeof _authenticatedComercialProdutoClientesWebCodigoAlterarDadosIndexRoute
  _authenticatedComercialProdutoClientesWebCodigoEmpresasBancoIndexRoute: typeof _authenticatedComercialProdutoClientesWebCodigoEmpresasBancoIndexRoute
}

const _authenticatedComercialProdutoClientesWebCodigoRouteRouteChildren: _authenticatedComercialProdutoClientesWebCodigoRouteRouteChildren =
  {
    _authenticatedComercialProdutoClientesWebCodigoBiowebRoute:
      _authenticatedComercialProdutoClientesWebCodigoBiowebRoute,
    _authenticatedComercialProdutoClientesWebCodigoCancelarContratoRoute:
      _authenticatedComercialProdutoClientesWebCodigoCancelarContratoRoute,
    _authenticatedComercialProdutoClientesWebCodigoMinhasSolicitacoesRoute:
      _authenticatedComercialProdutoClientesWebCodigoMinhasSolicitacoesRoute,
    _authenticatedComercialProdutoClientesWebCodigoOutrasSolicitacoesRoute:
      _authenticatedComercialProdutoClientesWebCodigoOutrasSolicitacoesRoute,
    _authenticatedComercialProdutoClientesWebCodigoAlterarDadosIndexRoute:
      _authenticatedComercialProdutoClientesWebCodigoAlterarDadosIndexRoute,
    _authenticatedComercialProdutoClientesWebCodigoEmpresasBancoIndexRoute:
      _authenticatedComercialProdutoClientesWebCodigoEmpresasBancoIndexRoute,
  }

const _authenticatedComercialProdutoClientesWebCodigoRouteRouteWithChildren =
  _authenticatedComercialProdutoClientesWebCodigoRouteRoute._addFileChildren(
    _authenticatedComercialProdutoClientesWebCodigoRouteRouteChildren,
  )

interface _authenticatedComercialProdutoClientesRouteRouteChildren {
  _authenticatedComercialProdutoClientesIndexRoute: typeof _authenticatedComercialProdutoClientesIndexRoute
  _authenticatedComercialProdutoClientesAquisicoesCodigoRouteRoute: typeof _authenticatedComercialProdutoClientesAquisicoesCodigoRouteRouteWithChildren
  _authenticatedComercialProdutoClientesHibridosIdRouteRoute: typeof _authenticatedComercialProdutoClientesHibridosIdRouteRouteWithChildren
  _authenticatedComercialProdutoClientesWebCodigoRouteRoute: typeof _authenticatedComercialProdutoClientesWebCodigoRouteRouteWithChildren
}

const _authenticatedComercialProdutoClientesRouteRouteChildren: _authenticatedComercialProdutoClientesRouteRouteChildren =
  {
    _authenticatedComercialProdutoClientesIndexRoute:
      _authenticatedComercialProdutoClientesIndexRoute,
    _authenticatedComercialProdutoClientesAquisicoesCodigoRouteRoute:
      _authenticatedComercialProdutoClientesAquisicoesCodigoRouteRouteWithChildren,
    _authenticatedComercialProdutoClientesHibridosIdRouteRoute:
      _authenticatedComercialProdutoClientesHibridosIdRouteRouteWithChildren,
    _authenticatedComercialProdutoClientesWebCodigoRouteRoute:
      _authenticatedComercialProdutoClientesWebCodigoRouteRouteWithChildren,
  }

const _authenticatedComercialProdutoClientesRouteRouteWithChildren =
  _authenticatedComercialProdutoClientesRouteRoute._addFileChildren(
    _authenticatedComercialProdutoClientesRouteRouteChildren,
  )

interface _authenticatedRouteRouteChildren {
  _authenticatedClientsRoute: typeof _authenticatedClientsRoute
  _authenticatedDashboardRoute: typeof _authenticatedDashboardRoute
  _authenticatedAtendimentoIndexRoute: typeof _authenticatedAtendimentoIndexRoute
  _authenticatedSemPermissaoIndexRoute: typeof _authenticatedSemPermissaoIndexRoute
  _authenticatedComercialProdutoClientesRouteRoute: typeof _authenticatedComercialProdutoClientesRouteRouteWithChildren
  _authenticatedComercialProdutoMaterialGraficoRoute: typeof _authenticatedComercialProdutoMaterialGraficoRoute
  _authenticatedComercialProdutoRelatorioRoute: typeof _authenticatedComercialProdutoRelatorioRoute
  _authenticatedSuportePacoteComunicacaoIndexRoute: typeof _authenticatedSuportePacoteComunicacaoIndexRoute
  _authenticatedSuporteTreinamentosIndexRoute: typeof _authenticatedSuporteTreinamentosIndexRoute
  _authenticatedComercialProdutoPrecosIndexRoute: typeof _authenticatedComercialProdutoPrecosIndexRoute
  _authenticatedComercialProdutoRegistrosIndexRoute: typeof _authenticatedComercialProdutoRegistrosIndexRoute
  _authenticatedComercialProdutoRelatoriosIndexRoute: typeof _authenticatedComercialProdutoRelatoriosIndexRoute
}

const _authenticatedRouteRouteChildren: _authenticatedRouteRouteChildren = {
  _authenticatedClientsRoute: _authenticatedClientsRoute,
  _authenticatedDashboardRoute: _authenticatedDashboardRoute,
  _authenticatedAtendimentoIndexRoute: _authenticatedAtendimentoIndexRoute,
  _authenticatedSemPermissaoIndexRoute: _authenticatedSemPermissaoIndexRoute,
  _authenticatedComercialProdutoClientesRouteRoute:
    _authenticatedComercialProdutoClientesRouteRouteWithChildren,
  _authenticatedComercialProdutoMaterialGraficoRoute:
    _authenticatedComercialProdutoMaterialGraficoRoute,
  _authenticatedComercialProdutoRelatorioRoute:
    _authenticatedComercialProdutoRelatorioRoute,
  _authenticatedSuportePacoteComunicacaoIndexRoute:
    _authenticatedSuportePacoteComunicacaoIndexRoute,
  _authenticatedSuporteTreinamentosIndexRoute:
    _authenticatedSuporteTreinamentosIndexRoute,
  _authenticatedComercialProdutoPrecosIndexRoute:
    _authenticatedComercialProdutoPrecosIndexRoute,
  _authenticatedComercialProdutoRegistrosIndexRoute:
    _authenticatedComercialProdutoRegistrosIndexRoute,
  _authenticatedComercialProdutoRelatoriosIndexRoute:
    _authenticatedComercialProdutoRelatoriosIndexRoute,
}

const _authenticatedRouteRouteWithChildren =
  _authenticatedRouteRoute._addFileChildren(_authenticatedRouteRouteChildren)

interface _publicRouteRouteChildren {
  _publicAlunoLoginRoute: typeof _publicAlunoLoginRoute
  _publicNovoClienteErroRoute: typeof _publicNovoClienteErroRoute
  _publicNovoClienteVerifiqueSeuEmailRoute: typeof _publicNovoClienteVerifiqueSeuEmailRoute
  _publicCadastroRevendedorIndexRoute: typeof _publicCadastroRevendedorIndexRoute
  _publicLoginIndexRoute: typeof _publicLoginIndexRoute
  _publicNovoClienteIndexRoute: typeof _publicNovoClienteIndexRoute
}

const _publicRouteRouteChildren: _publicRouteRouteChildren = {
  _publicAlunoLoginRoute: _publicAlunoLoginRoute,
  _publicNovoClienteErroRoute: _publicNovoClienteErroRoute,
  _publicNovoClienteVerifiqueSeuEmailRoute:
    _publicNovoClienteVerifiqueSeuEmailRoute,
  _publicCadastroRevendedorIndexRoute: _publicCadastroRevendedorIndexRoute,
  _publicLoginIndexRoute: _publicLoginIndexRoute,
  _publicNovoClienteIndexRoute: _publicNovoClienteIndexRoute,
}

const _publicRouteRouteWithChildren = _publicRouteRoute._addFileChildren(
  _publicRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  _authenticatedRouteRoute: _authenticatedRouteRouteWithChildren,
  _publicRouteRoute: _publicRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
